/* global jui, Class, jui, $H, $, $$, Ajax */
/* eslint-disable prefer-const */
const jQuery = require('jquery');
const Rx     = require('ub_wrapped/rx');
const _      = require('lodash');

const rxUi      = window.rxUi;
const endpoints = require('ub/config/endpoints').default;

const massDeleteButton = require('ub/lp/editor/buttons/mass-delete-button').default;

module.exports = Class.create(jui.Component, {
  options: function($super, options){
    return $super($H(
      {
        attributes:{className:'asset-view'},
        contextSwitchViews: ['images']
      }).merge(options));
  },

  initialize: function($super, options){
    this.assets = [];
    this.searchTerm = '';
    this.renameFields = {};
    this.field = {};
    this.selectedThumbs = [];
    this.selectedAssets = [];
    this.selectionStart = null;
    this.notice = null;
    this.type = null;
    this.companyId = window.editor.currentCompanyId;
    this.openAssetsCompanyId = this.companyId;
    this.unbounceId = window.editor.unbounceCompanyId;
    this.unbounceAssetsCompanyId = window.editor.unbounceAssetsCompanyId;
    this.name = options.name;
    this.sort = {
      by: 'id',
      direction: 'DSC'
    };

    $super(options);
  },

  _initRxUISubscriptions: function() {
    let getAssetFromEv = function(assetView, ev) {
      return _.find(assetView.assets, function(a) {
        return a.uuid === ev.data.assetUUID;
      });
    };

    let getAssetClickEvents = function(assetView) {
      let $imageSelector, assetClicked, assetDblClicked;

      $imageSelector = `#assets-view-${assetView.name} .thumb-container .thumb`;

      assetClicked = assetView._uiBinding
        .bindDOMLive($imageSelector, 'click', 'assetClicked')
        .map(function(ev){
          return _.merge(ev, _.pick(ev.origEvent, ['metaKey', 'shiftKey', 'ctrlKey']));
        });

      assetDblClicked = assetView._uiBinding
        .bindDOMLive($imageSelector, 'dblclick', 'assetDblClicked');

      return Rx.Observable
        .merge(assetClicked, assetDblClicked)
        .map(function(ev0) {
          delete ev0.origEvent;
          return ev0;
        })
        .filter(function(ev) {
          return ! _.isEmpty(ev._domTarget);
        })
        .map(function addAssetToEv(ev) {
          let uuid = jQuery(`#${ev._currentTarget}`)
                .parents('.thumb-container')
                .attr('data-asset-id');
          return _.merge(ev, {data: {assetUUID: uuid}});
        });
    };

    let getAssetRenameEvents = function(assetView) {
      let renameEvs = assetView._uiBinding
        .filterByEventType('assetRenamed')
        .do(function(ev) {
          assetView.hideThumbRenameFieldByAsset(getAssetFromEv(assetView, ev));
        });

      renameEvs
        .filter(function(ev) {
          return ev.data.oldName === ev.data.newName ||
            _.isEmpty(ev.data.newName);
        })
        .do(function(ev) {
          assetView.getAssetThumbElByUUID(getAssetFromEv(assetView, ev).uuid).down('p').show();
        })
        .subscribe(_.noop);

      return renameEvs
        .filter(function(ev) {
          return ev.data.oldName !== ev.data.newName && ! _.isEmpty(ev.data.newName);
        });
    };

    let getAssetSelectedEvents = function(assetView) {
      let singleSelectEvs = assetView._uiBinding
        .filterByEventType('assetSelected');

      let multiSelectEvs = assetView._uiBinding
        .filterByEventType('assetMultiSelected');

      return singleSelectEvs
        .merge(multiSelectEvs)
        .do(function(){
          //Trigger a rename on any previously selected asset.
          _.each(assetView.selectedAssets, assetView.triggerRenameAsset.bind(assetView));
        });
    };

    let assetDispatchTable = {
      assetClicked       : this.assetClicked.bind(this),
      assetDblClicked    : this.assetDblClicked.bind(this),
      assetRenamed       : this.renameAsset.bind(this),
      assetSelected      : this.selectAsset.bind(this),
      assetMultiSelected : this.selectMultipleAssets.bind(this)
    };

    let self = this;
    getAssetClickEvents(this)
      .merge(getAssetRenameEvents(this))
      .merge(getAssetSelectedEvents(this))
      .filter(function getEvsWithAssets(ev) {
        return ! _.isEmpty(_.find(self.assets, function(a) {
          return a.uuid === ev.data.assetUUID;
        }));
      })
      .ub_subscribe(function(ev) {
        assetDispatchTable[ev.type](ev, getAssetFromEv(self, ev));
      });
  },

  installUI: function($super) {
    /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
    $super();
    this.assetPane = this.insert(
      new jui.Component({attributes: {id: `assets-view-${this.name}`,
                                      className: 'asset-pane'}}));
    this.assetPaneContents = this.assetPane.insert(new Element('div', {className: 'asset-pane-contents'}));
    this._uiBinding = new rxUi.Binding(['AssetChooserView', this.name]);
    this._initRxUISubscriptions();

    // Image unveiling
    let scrollObservable = Rx.Observable
    .fromEvent(this.assetPane.e, 'scroll')
    .throttle(35);

    scrollObservable.subscribe(this._triggerUnveilImages.bind(this));
    scrollObservable.subscribe(this._updateHeaderClass.bind(this));
  },

  _updateHeaderClass: function(ev) {
    if (ev.target.scrollTop > 0) {
      this.toolbar.addClassName('toolbar-has-shadow');
    } else {
      this.toolbar.removeClassName('toolbar-has-shadow');
    }
  },

  _triggerUnveilImages: function(){
    Rx.Observable.interval(80)
      .merge(Rx.Observable.return(null)) // fire now
      .take(5)
      .subscribe(this._unveilImages.bind(this));
  },

  unveilImages: function() {
    if (this.type === 'images') {
      this._unveilImages();
    }
  },

  _unveilImages: function() {
    let scrollViewThreshold = 450;
    jQuery(this.assetPane.e)
      .find('.unveil')
      .unveil(scrollViewThreshold, function() {
        this.removeClassName('unveil');
    });
  },

  clear: function() {
    this.assetPaneContents.update('');
    this.assets = [];
    this.clearSelection();
  },

  prepareForLoading: function() {
    this.clear();
    this.clearSearchField();
  },

  showToolbar: function() {
    this.insert(this.toolbar);
  },

  buildAssetFilterToolbar: function(type) {
    if (this.toolbar) {
      return this.toolbar;
    }

    let toolbar = new jui.Component({attributes:{className: 'filter-orderby-toolbar'}});

    this.massDeleteButton = massDeleteButton.create(jui, this.options.onMassDelete);

    this.assetFilterSelect = this.assetFilterSelect || this.assetFilter();
    this.search = this.search || this.assetSearch();
    this.sortFilter = this.sortFilter || this.buildSortFilter();

    if(this.options.contextSwitchViews.include(type)) {
      toolbar.insert(this.assetFilterSelect);
    }
    toolbar.insert(this.massDeleteButton);
    toolbar.insert(this.search);
    toolbar.insert(this.sortFilter);
    return toolbar;
  },

  assetSearch: function() {
    return new jui.FormTextInput({
      attributes: {className: 'search-field modal-search-field', id: 'modal-search-input'},
      label: '&nbsp;',
      labelClassName: 'modal-search-label svg-ico-search',
      inputClassName: 'modal-search-input',
      inputId: 'modal-search-input',
      onblur: function(e) {
        e.data.e.removeClassName('focus');
      },
      onfocus: function(e) {
        window.editor.keyController.requestFocus(this);
        e.data.e.addClassName('focus');
      }
    });
  },

  assetFilter: function() {
    let self = this;
    return new jui.FormSelect({
      attributes: {className: 'asset-context-switcher'},
      width: '190px',
      label: '',
      id: 'jui-asset-chooser-select',
      dropDownClassName: 'modal-dropdown-list modal-select2-dropdown',
      selectOptions: [
        {name: 'My Images', value: self.companyId},
        {name: 'Unbounce Public Images', value: self.unbounceAssetsCompanyId}
      ],
      action: this._uiBinding.wrapCallbackWithData('assetFilterSelected', function(e) {
        if(parseInt(e.data, 10) === self.unbounceAssetsCompanyId){
          jQuery('.js-upload-images-button').hide();
        } else {
          jQuery('.js-upload-images-button').show();
        }
        self.buildSearch();
        self.fireEvent('companyFilterChanged', e.data);
        self.clearSearchField();
      })
    });
  },

  buildSortFilter: function() {
    let self = this;
    this.assetSortTab = new jui.AssetSortTab({
      sortTabButtons: [
        {name: 'Created', id: 'id'},
        {name: 'Name', id: 'content_file_name'},
        {name: 'Filesize', id: 'content_file_size'}
      ],
      toggle: this._uiBinding.wrapCallbackWithData('assetsSorted', function(e) {
        let assets = self.sortAssets(self.assets, e.data.action, e.data.direction);
        self.loadAssets(assets, self.type, self.openAssetsCompanyId, true);
        self._triggerUnveilImages();
      })
    });
    return this.assetSortTab;
  },

  initializeToolbar: function() {
    this.clear();
    this.showToolbar();
  },

  initializeAssetsInView: function(assets, type) {
    let self = this;
    this.type = type;

    if (assets.length > 0) {
      let $paneContents = jQuery(this.assetPaneContents);
      $paneContents.detach(); // detach to avoid the cost of repainting while creating the thumb node
      this.assetPane.e.removeClassName('empty');
      assets.each(function(asset){
        self.showAsset(asset);
      }, this);
      $paneContents.appendTo(this.assetPane.e);
    } else {
      this.addEmptyMessage(type);
    }

    this.assets = assets;
  },

  addEmptyMessage: function(type) {
    this.assetPane.e.addClassName('empty');
    let emptyMessage = "<p>Click the button below to upload new images from your computer.</p>";

    this.notice = this.assetPaneContents.insert(new Element('p', {className:'note js-no-asset-notice no-asset-notice'})
      .update(
        `<svg class='asset-note-icon'viewBox='0 0 100 100'>
          <path d='M79,31L64,16c-0-0-0-0-0-0c-0-0-0-0-0-0H26c-3,0-5,2-5,5v61c0,3,2,5,5,5h48c3,
            0,5-2,5-5V32c0-0,0-0-0-0C79,31,79,31,79,31z M67,30.5c-2,0-3-1-3-3v-7l10,10H67z
            M73,84H27c-2,0-3-1-3-3V22c0-2,1-3,3-3h34v9c0,3,2,5,5,5H76v47C76,82,75,84,73,84z'/>
          <ellipse cx='38' ry='3.5' rx='2.25' cy='57'/>
          <ellipse cx='62' ry='3.5' rx='2.25' cy='57'/>
          <circle cx='50' cy='68' r='4.5'/>
        </svg><div class='asset-note-headline'>Uh-oh! You don't have any ${type} available.</div> ${emptyMessage}`
    ));

    jQuery('.js-upload-images-button').addClass('action');
  },

  getAssetThumbElByUUID: function(uuid) {
    return $(`thumb_${uuid}`);
  },

  updateAssetElLabel: function(thumb, label) {
    thumb.down('p').update(label);
  },

  updateContainerTitle: function(thumb, label) {
    thumb.writeAttribute('title', label);
  },

  hideThumbLabelByUUID: function(uuid) {
    this.getAssetThumbElByUUID(uuid).down('p').hide();
  },

  hideThumbRenameFieldByAsset: function(asset) {
    if(_.has(this.renameFields, asset.uuid)) {
      this.renameFields[asset.uuid].hide();
      jQuery(`thumb_${asset.uuid}`).removeClass('renaming');
    }
  },

  showThumbRenameFieldByAsset: function(asset) {
    this.renameFields[asset.uuid].show();
    this.field[asset.uuid].focusAndSelect();
    jQuery(`thumb_${asset.uuid}`).addClass('renaming');
  },

  makeAssetRenameable: function(asset) {
    this.hideThumbLabelByUUID(asset.uuid);
    this.showThumbRenameFieldByAsset(asset);
  },

  updateAssetImgSrc: function(thumb, asset) {
    if(/image/i.test(asset.content_content_type)) {
      thumb.down('img').setAttribute('src', asset.content_url_small);
    }
  },

  addRenameFieldToThumb: function(asset) {
    this.field[asset.uuid] = new jui.FormTextInput({
      onkeydown: _.noop,
      onFocus: _.noop,
      onblur: this.triggerRenameAsset.bind(this, asset)
    });
    let button = new jui.Button({
      action: this.triggerRenameAsset.bind(this, asset)
    });
    button.setLabel('&#10004;');//Checkmark.
    this.renameFields[asset.uuid] = new jui.Component({attributes: {className: 'asset-rename-field'}});
    this.renameFields[asset.uuid].insert(this.field[asset.uuid]);
    let name = "";

    if( ! _.isEmpty(asset.name)) {
      name = asset.name.split('.').first();
    }

    this.field[asset.uuid].setValue(name);
    return this.renameFields[asset.uuid];
  },

  updateThumbEl: function(asset) {
    let thumb = this.getAssetThumbElByUUID(asset.uuid);
    this.updateAssetElLabel(thumb, asset.content_file_name);
    this.updateAssetImgSrc(thumb, asset);
    this.updateContainerTitle(thumb, asset.content_file_name);
  },

  showAsset: function(asset) {
    let thumb = this.addButtonsToThumb(asset);
    this.assetPaneContents.insert(thumb);
    this._assetFadeIn(thumb);
  },

  _assetFadeIn: function(thumb) {
    setTimeout(function () {
      jQuery(thumb).removeClass('invisible');
    }, 0);
  },

  updateAssetThumb: function(asset) {
    this.updateAssetsArray(asset);
    this.updateThumbEl(asset);

    let name = '';

    if ( ! _.isEmpty(asset.name)) {
      name = asset.name.split('.').first();
    }

    this.field[asset.uuid].setValue(name);
    this.buildSearch();
    this.reloadSelectedAsset(asset);
  },

  updateAssetsArray: function(asset) {
    let i;
    let index;

    for(i = 0; i <= this.assets.length; i++) {
      if(parseInt(this.assets[i].id, 10) === parseInt(asset.id, 10)) {
        index = i;
        break;
      }
    }
    this.assets.splice(index, 1, asset);
  },

  showAssets: function(assets, type) {
    this.initializeToolbar();
    this.initializeAssetsInView(assets, type);
    this._triggerUnveilImages();
    this.search.setValue(this.searchTerm);
  },

  loadAssets: function(assets, type, companyId) {
    this.clear();
    this.toolbar = this.buildAssetFilterToolbar(type);
    this.selectCurrentCompanyInFilter(companyId);
    this.openAssetsCompanyId = parseInt(companyId, 10);
    this.showAssets(assets, type);
    //Reload Image Cache for the search.
    setTimeout(this.buildSearch.bind(this), 15);
  },

  getUUIDFromIdString: function(string) {
    return string.split('_')[1];
  },

  buildSearch: function() {
    let self = this;
    let searchField = $$('.search-field').first();

    if(searchField) {
      let searchInputField = searchField.down('input');
      searchInputField.focus();
      this.qsSearch = new jui.QuicksilverAssetSearch(searchInputField, $$('.thumb-container'), {
        afterDisplayResults: function() {
          //Selects the first asset
          let firstVisibleAsset = $$('.thumb.small').find(function(asset){
            return $(asset).up('.thumb-container').visible();
          });

          if(firstVisibleAsset) {
            let uuid = self.getUUIDFromIdString(firstVisibleAsset.identify());
            let assetElm = _.find(self.assets, function(a) { return a.uuid === uuid; });
            self.triggerSelectAsset(assetElm);
            self._triggerUnveilImages();
          }
        },
        afterKeyPress: function(e) {
          self.searchTerm = self.search.getValue();
          if(e.data.keyCode === 13) {
            let selectedAsset = $$('.thumb.small.selected').first();
            if(selectedAsset) {
              let assetUuid = self.getUUIDFromIdString(selectedAsset.identify());
              let asset = self.assets.find(function(a){
                return a.uuid === assetUuid;
              });
              if(asset) {
                self.fireEvent('assetDblClicked', asset);
              }
            }
          }
        }
      });
    }
  },

  clearSearchField: function() {
    if(this.search) {
      this.search.setValue('');
      this.searchTerm = '';
    }
  },

  sortAssets: function(assets, which, direction) {
    //Sort by content_file_name, content_file_size, content_updated_at
    assets = jui.utils.sort(assets, which, direction);
    return assets;
  },

  isManageable: function() {
    return (this.companyId === this.unbounceAssetsCompanyId) || (this.unbounceAssetsCompanyId !== this.openAssetsCompanyId);
  },

  selectCurrentCompanyInFilter: function(companyId) {
    this.assetFilterSelect.setSelectedValue(companyId);
  },

  addAsset: function(asset) {
    if (this.notice !== null) {
      this.assetPane.e.removeClassName('empty');
      jQuery('.js-no-asset-notice').remove();
      this.notice = null;
    }

    this.assets.unshift(asset);
    let thumb = this.addButtonsToThumb(asset);

    this.assetPaneContents.insert({top: thumb});
    this._assetFadeIn(thumb);
    this.clearSearchField();
    this._triggerUnveilImages();
    this.buildSearch();
  },

  shouldLoadFullImage: function (type) {
    return type === 'image/svg+xml';
  },

  buildThumbContainer: function (fileName, uuid) {
    let thumbContainer = document.createElement('DIV');
    thumbContainer.setAttribute('title', fileName);
    thumbContainer.setAttribute('data-asset-id', uuid);
    thumbContainer.className = 'thumb-container invisible';
    thumbContainer.setAttribute('id', `container_${uuid}`);

    return thumbContainer;
  },

  buildImageNode: function (src, uuid) {
    let imgNode = document.createElement('IMG');
    imgNode.className = 'unveil';
    // transparent single pixel
    imgNode.setAttribute('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
    imgNode.setAttribute('data-src', src);
    imgNode.setAttribute('id', `image_${uuid}`);

    return imgNode;
  },

  buildImageContainer: function (imgNode) {
    let imgContainer = document.createElement('DIV');
    imgContainer.className='image-thumb-container';
    if (imgNode !== null) {
      imgContainer.appendChild(imgNode);
    } else {
      imgContainer.classList.add('file-icon');
    }

    return imgContainer;
  },

  buildThumbNode: function (uuid, imgContainer, nameP) {
    let thumb = document.createElement('DIV');
    thumb.setAttribute('id', `thumb_${uuid}`);
    thumb.className = 'thumb small thumb-thumb';
    thumb.appendChild(imgContainer);
    thumb.appendChild(nameP);

    return thumb;
  },

  buildImageLabel: function (uuid, fileName) {
    let nameP = document.createElement('P');
    nameP.setAttribute('id', `name_${uuid}`);
    nameP.className = 'thumb-title';
    nameP.innerText = fileName;

    return nameP;
  },

  getThumbnailImage: function(asset) {
    if (this.shouldLoadFullImage(asset.content_content_type)){
      return asset.content_url;
    } else if (asset.content_content_type.startsWith('image')) {
      return asset.content_url_small;
    } else {
      return null;
    }
  },

  addButtonsToThumb: function(asset) {
    let src = this.getThumbnailImage(asset);
    let thumbContainer = this.buildThumbContainer(asset.content_file_name, asset.uuid);
    let imgNode = src !== null ? this.buildImageNode(src, asset.uuid) : null;
    let imgContainer = this.buildImageContainer(imgNode);
    let nameP = this.buildImageLabel(asset.uuid, asset.content_file_name);
    let thumb = this.buildThumbNode(asset.uuid, imgContainer, nameP);

    thumbContainer.appendChild(thumb);

    this._addButtonsToThumb(asset, thumb);

    return thumbContainer;
  },

  clearSelection: function() {
    this.selectedAssets = [];
    this.updateSelectedThumbs();
    this.fireEvent('assetSelectionChanged');
  },

  removeAssetsById: function(ids) {
    let assets = this.assets.collect(function(asset) {
      /* jscs:disable requireSpaceAfterBinaryOperators */
      /* jscs:disable requireSpaceAfterPrefixUnaryOperators  */
      return ids.indexOf(Number(asset.id)) > -1 ? null : asset;
    }).compact();
    this.buildSearch();
    this.showAssets(assets, this.type);
  },

  updateSelectedThumbs: function() {
    this.selectedThumbs.each(function(thumb) {
      thumb.up().removeClassName('selected');
      thumb.removeClassName('selected');
      thumb.removeClassName('renaming');
    });

    this.selectedThumbs = [];

    this.selectedAssets.each(function(asset) {
      /* jscs:disable requireDollarBeforejQueryAssignment */
      let thumb = $(`thumb_${asset.uuid}`);
      if(thumb) {
        let container = thumb.up();
        thumb.addClassName('selected');
        container.addClassName('selected');
        this.selectedThumbs.push(thumb);
      }
    }, this);

    if (this.selectedAssets.length === 1) {
      this.selectionStart = this.selectedAssets[0];
    } else if (this.selectedAssets.length === 0) {
      this.selectionStart = null;
    }
  },

  _addButtonsToSelectedThumb: function(asset, thumb) {
    let self = this;
    if(jQuery(thumb).find('.asset-rename-field').length === 0) {
      self._addButtonsToThumb(asset, thumb);
    }
  },

  _addButtonsToThumb: function(asset, thumb) {
    let self = this;

    if (this.isManageable()) {
      thumb.insert(this.addRenameFieldToThumb(asset).e);
      this.hideThumbRenameFieldByAsset(asset);

      let renameButton = new jui.IconButtonWithLabel(
        'edit',
        {
          action  : function() {
            self._uiBinding.onNext({
              type           : 'assetClicked',
              _currentTarget : jQuery(thumb).attr('id'),
              _domTarget     : `rename-${asset.uuid}`
            });
            self.makeAssetRenameable(asset);
          }
        });

      let deleteButton = new jui.IconButtonWithLabel(
        'delete', {
          action  : this.deleteAsset.bind(this, asset)
        });

      thumb.insert(deleteButton.e);
      thumb.insert(renameButton.e);
    }
  },

  findSelectedAssetIndexByUUID: function(uuid) {
    let index = -1;
    this.selectedAssets.each(function(asset, i){
      if(asset.uuid === uuid) {
        index = i;
        return;
      }
    });
    return index;
  },

  reloadSelectedAsset: function(asset) {
    let indexOfAsset = this.findSelectedAssetIndexByUUID(asset.uuid);
    if(indexOfAsset > -1) {
      this.selectedAssets.splice(indexOfAsset, 1, asset);
    }
  },

  assetClicked: function(ev, asset) {
    if(_.any(['shiftKey', 'metaKey', 'ctrlKey'], function(prop) {
      return Boolean(ev[prop]);
    })) {
      this.triggerMultiSelectAsset(asset, ev);
    } else {
      this.triggerSelectAsset(asset, ev);
    }
  },

  assetDblClicked: function(__, asset) {
    let assetBrowser = window.editor.assetChooser.assetBrowser;
    assetBrowser.fireEvent('assetDblClicked', asset);
  },

  triggerSelectAsset: function(asset, ev) {
    // We are not guaranteed an asset. If there is no asset short circuit quickly
    if ( ! asset) { return; }

    this._uiBinding.onNext({
      type        : 'assetSelected',
      ev          : ev,
      data        : {
        assetUUID : asset.uuid
      }
    });
  },

  triggerMultiSelectAsset: function(asset, ev) {
    this._uiBinding.onNext({
      type        : 'assetMultiSelected',
      ctrlKey     : ev.ctrlKey,
      shiftKey    : ev.shiftKey,
      metaKey     : ev.metaKey,
      data        : {
        assetUUID : asset.uuid
      }
    });
  },

  selectMultipleAssets: function(ev, asset) {
    if (ev.metaKey || ev.ctrlKey) {
      let i = this.selectedAssets.indexOf(asset);
      if (i > -1) {
        this.selectedAssets.splice(i, 1);
        this.updateSelectedThumbs();
        this.fireEvent('assetSelectionChanged');
        return;
      }
      this.selectedAssets.push(asset);
    } else if (ev.shiftKey) {
      if (this.selectedAssets.length === 0) {
        this.selectedAssets.push(asset);
      } else if (this.selectedAssets.indexOf(asset) === -1) {
        let from = this.assets.indexOf(this.selectionStart);
        let to = this.assets.indexOf(asset);
        if (from > to) {
          let temp = to;
          to = from;
          from = temp;
        }

        this.selectedAssets = [];
        let index;

        for (index = from; index <= to; index++) {
          this.selectedAssets.push(this.assets[index]);
        }
      }
    }
    this.updateSelectedThumbs();
    this.fireEvent('assetSelectionChanged');
  },

  selectAsset: function(ev, asset) {
    this.selectedAssets = [];
    this.selectedAssets.push(asset);

    jQuery('.js-upload-images-button').removeClass('action');
    this.updateSelectedThumbs();
    this.fireEvent('assetSelectionChanged');

    // TODO : The asset browser should scroll down to the selected image.
    // let selected = this.selectedThumbs[0];
    // if (selected) {
    // this.assetPane.e.scrollTop = Math.max(selected.positionedOffset().top + selected.getHeight() - this.getHeight(), 0);
    // }
  },

  deleteAsset: function(asset) {
    this.fireEvent('assetDeleteClicked', asset);
  },

  triggerRenameAsset: function(asset) {
    let newName,
      fileNameArray = asset.content_file_name.split('.'),
      nameParts = {
        name: fileNameArray.first().toLowerCase(),
        ext: fileNameArray.last().toLowerCase()
      },
      oldName = nameParts.name;

    if(_.isUndefined(this.field[asset.uuid])) {
      newName = oldName;
    } else {
      newName = this.field[asset.uuid].getValue().toLowerCase();
    }

    this._uiBinding.onNext({
      type: 'assetRenamed',
      data: {
        assetUUID: asset.uuid,
        nameParts: nameParts,
        newName: newName,
        oldName: oldName
      }
    });
  },

  renameAsset: function(ev, asset) {
    function sluggifyName(name) {
      let slugifyStrip = /[^\w\s-]/g;
      let slugifyHyphenate = /[-\s]+/g;
      name = name.replace(slugifyStrip, '-').trim().toLowerCase();
      return name.replace(slugifyHyphenate, '-');
    }

    let self         = this;
    let assetBrowser = window.editor.assetChooser.assetBrowser;
    let thumb        = this.getAssetThumbElByUUID(asset.uuid);
    let renaming     = new Element('div', {className: 'renaming-asset'}).update('Renaming...');
    let newName      = `${sluggifyName(ev.data.newName)}.${ev.data.nameParts.ext}`;
    let url          = endpoints.assetById(asset.id);
    let postBody     = `asset[name]=${newName}&_method=PUT`;

    return new Ajax.Request(url, {
      method: 'post', //Doing a PUT
      postBody: postBody,
      onLoading: function() {
        self.updateAssetElLabel(thumb, renaming);
        self.getAssetThumbElByUUID(asset.uuid).down('p').show();
        assetBrowser.disable();
      },
      onLoaded: function() {
        assetBrowser.enable();
      },
      onSuccess: function(transport) {
        self.updateAssetThumb(transport.responseJSON);
        assetBrowser.fireEvent('updated');
        window.localStorage.removeItem(`assets${window.editor.currentCompanyId}`);
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/lp/editor/ub-asset-view.js